import React, { FC, useState } from "react";
import { IconButton, Stack } from "@mui/material";
import CollapseChildren from "./CollapseChildren";
import IconComponent from "../components/ui/IconComponent";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Text from "./Text";

interface PaperCollapseProps {
  label: string;
  children: React.ReactNode;
  collapsed?: boolean;
}

const PaperCollapse: FC<PaperCollapseProps> = ({ label, children, collapsed }) => {
  const theme = useTheme();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(
    collapsed !== undefined ? collapsed : false
  );

  const handleCollapse = () => {
    setIsCollapsed((prevState) => !prevState);
  };

  return (
    <>
      <Stack
        direction="row"
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        onClick={() => handleCollapse()}
      >
        <Text variant="h3">{label}</Text>
        <IconButton
          sx={{
            transition: "transform ease-in-out .18s",
            transform: `${isCollapsed ? "rotate(180deg)" : "none"}`,
          }}
        >
          <IconComponent iconName={"chevron-down"} hasFill hasStroke />
        </IconButton>
      </Stack>
      <CollapseChildren show={isCollapsed} initialMargin={8}>
        {children}
      </CollapseChildren>
      <Box
        sx={{
          backgroundColor: theme.palette.grey[200],
          height: "1px",
          width: "100%",
          marginTop: `${isCollapsed ? "16px" : "0px"} !important`,
        }}
      />
    </>
  );
};

export default PaperCollapse;
